import { Spin } from 'antd';

/** 全局/页面级加载占位 */
export default function PageLoading({
  height = '100vh',
}: {
  height?: number | string;
}) {
  return (
    <div className="flex items-center justify-center" style={{ height }}>
      <Spin size="large" />
    </div>
  );
}
